import PageHero from '../components/PageHero';

const plans = [
  {
    name: 'Full time',
    price: '$220',
    cadence: 'per week',
    detail: 'Six days a week, Monday to Saturday. Closed Sundays.',
    featured: true,
  },
  {
    name: 'Part time',
    price: '$175',
    cadence: 'per week',
    detail: 'Three days a week, Monday to Saturday. Closed Sundays.',
    featured: false,
  },
];

const BoothInquiry = () => (
  <div className="page">
    <PageHero kicker="Booth rental" title="Rent a chair. Keep your book.">
      Are you a licensed stylist looking for a warm, well-lit room to call your
      own? The Loft offers full-time and part-time booth rentals, and we would
      love to have you.
    </PageHero>

    <section className="section">
      <div className="container booth">
        <div className="booth__plans">
          {plans.map((plan) => (
            <div className={`booth-plan reveal${plan.featured ? ' booth-plan--featured' : ''}`} key={plan.name}>
              {plan.featured && <span className="booth-plan__tag">Most popular</span>}
              <h3>{plan.name}</h3>
              <p className="booth-plan__price">
                <span>{plan.price}</span>{` ${plan.cadence}`}
              </p>
              <p className="booth-plan__detail">{plan.detail}</p>
            </div>
          ))}
        </div>

        <div className="booth__why reveal" data-reveal="120">
          <h2>Why stylists stay at The Loft</h2>
          <ul className="booth__list">
            <li>Your own chair, your own schedule, your own clients.</li>
            <li>A streetside suite at Vineyard Commons with great natural light.</li>
            <li>A small, supportive team of independent pros, not a chain.</li>
            <li>Eufora and retail available in the salon.</li>
          </ul>
        </div>
      </div>
    </section>

    <section className="section--tight section--dark grain">
      <div className="container booth-cta">
        <div className="reveal">
          <span className="kicker">Next step</span>
          <h2>Request the inquiry form.</h2>
          <p className="lede">
            Fill out the booth rental inquiry form and email it
            to <a className="link" href="mailto:theloftsalon@tlst.us">theloftsalon@tlst.us</a>.
            We will be in touch to set up a time to meet and tour the space.
          </p>
        </div>
        <div className="btn-row reveal" data-reveal="120">
          <a className="btn btn--primary" href="/RENTAL-INQUIRY.pdf" target="_blank" rel="noopener noreferrer">
            Booth rental inquiry form
          </a>
          <a className="btn btn--outline" href="mailto:theloftsalon@tlst.us">Email us a question</a>
        </div>
      </div>
    </section>
  </div>
);

export default BoothInquiry;
